<template>
    <div v-if="bedrijven.length != 0" class="wrapper">
        <item-form
            :model="model"
            :bedrijven="bedrijven"
            :glastypes="glastypes"
            :soortbelichtingen="soortbelichtingen"
            :isEditing="false"
            @save-item="addItem">
        </item-form>

        <b-modal title="Toevoegen" size="sm" class="modal-danger" v-model="warningModal" @ok="closedialog">
            FOUT: Afdeling werd niet toegevoegd! {{errormsg}}
        </b-modal>
    </div>
</template>

<script>
    import api from '../../api/afdeling';
    import ItemForm from './Form';

    export default {
        data () {
            return {
                warningModal: false,
                errormsg: '',
                bedrijven: [],
                glastypes: [],
                soortbelichtingen: [],
                model: {
                    belichting_n: [],
                },
            };
        },
        created () {
            api.getDetailAfdeling(0).then((response) => {
                this.bedrijven = response.data.bedrijven;
                this.glastypes = response.data.glastypes;
                this.soortbelichtingen = response.data.soortbelichtingen;
            });
        },
        methods: {
            addItem (model) {
                api.addAfdeling(model).then(() => {
                    this.$router.replace('/beheer/afdeling');
                },
                (error) => {
                    this.errormsg = error.message;
                    this.warningModal = true;
                });
            },
            closedialog () {
                this.warningModal = false;
            },
        },
        components: {
            'item-form': ItemForm,
        },
    };
</script>



// WEBPACK FOOTER //
// src/pages/afdeling/New.vue